module.exports = __webpack_public_path__ + "img/EJSClogo2_new.4e9ef58c.png";